// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__OoM5A","load1":"Spinner_load1__x9wmu"};